import axios, { AxiosError } from "axios";

/**
 * Single axios instance for the entire SPA.
 *
 * - In dev: baseURL is "" so requests go through Vite's proxy to FastAPI.
 * - In prod: same origin (the FastAPI container serves the SPA + API).
 * - withCredentials: cookies are first-party; this lets axios attach them.
 */
export const api = axios.create({
  baseURL: "",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

/** True if the error is a 401 (unauthenticated). */
export function isUnauthorized(error: unknown): boolean {
  return error instanceof AxiosError && error.response?.status === 401;
}
